export default __webpack_public_path__ + "static/media/lp-sec07_benefits04.284b6c08.png";